import React, { useContext, useEffect, useState } from 'react';
import { BuildPlanContext } from '../../contexts/DTC/DTCContext';
import SelectionCard from '../SelectionCard';
import styles from '../BuildPlan.module.css';
import { ReactComponent as Washer } from '../../../assets/images/washer.svg';
import cn from 'classnames';
import AddPlanCard from '../AddPlanCard';

const ShopCategoryPlans = () => {
    const { state, dispatch } = useContext(BuildPlanContext);
    const {
        currentStep: {
            category,
            category: { subCategories }
        },
        selectedSubcategory
    } = state;

    const [currentSubcategory, setCurrentSubcategory] = useState(null);

    useEffect(() => {
        setCurrentSubcategory(
            subCategories.find((sc) => {
                return sc.subCategoryId === selectedSubcategory;
            })
        );
    }, [selectedSubcategory]);

    const headerQuestion = {
        appliances: 'QUESTION SCRIPTING FOR APPLIANCES',
        hvac: 'Would you like to protect an HVAC unit or a single unit?',
        electrical: 'QUESTION SCRIPTING FOR ELECTRICAL',
        utilities: 'You can mix and match utility plans to best fit your needs',
        plumbing: 'Want to add protection for your plumbing system or hot water heater?'
    };

    const handleSelect = (selectedSubcategory) => {
        dispatch({
            type: 'INIT',
            payload: {
                selectedSubcategory
            }
        });
    };

    return (
        <div>
            <h3 className='h6'>{headerQuestion[category.id]}</h3>
            <div className={cn(styles.flex, styles.justifyCenter)}>
                {subCategories
                    && subCategories.map((sc) => (
                        <SelectionCard
                            title={sc.subCategoryName}
                            icon={<Washer className={styles.categoryIcon} />}
                            checked={sc.subCategoryId === state.selectedSubcategory}
                            onClick={() => handleSelect(sc.subCategoryId)}
                            type='radio'
                        />
                    ))}
            </div>
            <div className={cn(styles.flex, styles.flexCol, styles.justifyCenter, styles.alignCenter, 'my-4')}>
                {currentSubcategory?.plans.length > 0 && currentSubcategory.plans.map((p) => <AddPlanCard plan={p} />)}
            </div>
        </div>
    );
};

export default ShopCategoryPlans;
